import React, { useEffect } from 'react';
import { useToggle, useWindowScroll } from 'react-use';

export default () => {
  const { y } = useWindowScroll();
  const [stick, setStick] = useToggle();

  useEffect(() => {
    if (!stick && y >= 152) {
      setStick(true);
      document.body.classList.add('stick');
    }

    if (stick && y < 152) {
      setStick(false);
      document.body.classList.remove('stick');
    }
  }, [y]);

  return <></>;
};
